import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { EFDataService, EFFilterData, EnvironmentService, PGUtilities } from 'pg-lib';

@Component({
    selector: 'app-ef-showcase-view',
    templateUrl: './ef-showcase-view.component.html',
    styleUrls: ['./ef-showcase-view.component.scss'],
    standalone: false
})
export class EfShowcaseViewComponent implements OnInit {
    constructor(private environmentService:EnvironmentService, private route:ActivatedRoute, private dataService:EFDataService) { }

    isLoading = false;

    environmentPid:string = null;
    realmId:string = null;
    productsFilter:EFFilterData = null;
    showcaseContent:Array<{
        type: string;
        element: string;
    }> = null;
    showcaseWithQR:string = null;

    private _loadFinderEnvironmentInterval = null;

    private _externalFilterArrayOrSplit(val:string|Array<string>) {
        if(typeof val == 'string') {
            if(val.startsWith('[') && val.endsWith(']')) {
                try {
                    return JSON.parse(val)
                }
                catch(ex) {
                    return PGUtilities.parseCommaSeparatedList(val)
                }
            }
            else {
                return PGUtilities.parseCommaSeparatedList(val)
            }
        }
        else return val;
    }

    private _handleFilter(value:any) {
        let _result = new EFFilterData()

        for(let i in value) {
            if(typeof _result[i] != 'undefined') {
                _result[i] = this._externalFilterArrayOrSplit(value[i])
            }
        }
        
        return _result;
    }

    ngOnInit(): void {
        this.route.params.subscribe((params) => {
            this.environmentPid = null;
            this.realmId = null;
            this.showcaseContent = null;
            this.productsFilter = null;

            if(this._loadFinderEnvironmentInterval != null) {
                clearInterval(this._loadFinderEnvironmentInterval)
                this._loadFinderEnvironmentInterval = null;
            }

            if(params.pid) {
                this.environmentPid = params.pid
                this.isLoading = true;

                let _lastShowcase = null;

                this.dataService.getFinderEnvironment(this.environmentPid).subscribe((data) => {
                    this.isLoading = false;

                    this.realmId =  data.realm_id;

                    if(data.data.showcase) {
                        this.showcaseWithQR = data.data.showcaseWithQR;
                        this.showcaseContent = data.data.showcaseContent
                    }

                    if(data.data.filter) {
                        this.productsFilter = this._handleFilter(data.data.filter)
                    }

                    _lastShowcase = JSON.stringify(this.realmId) + JSON.stringify(this.showcaseWithQR) + JSON.stringify(this.showcaseContent) + JSON.stringify(this.productsFilter)
                })

                this._loadFinderEnvironmentInterval = setInterval(() => {
                    this.dataService.getFinderEnvironment(this.environmentPid).subscribe((data) => {

                        let _setRealm = data.realm_id;

                        let _setContent = null;
                        let _setWithQR = null;

                        if(data.data.showcase) {
                            _setContent = data.data.showcaseContent;
                            _setWithQR = data.data.showcaseWithQR;
                        }

                        let _setFilter = null;
                        if(data.data.filter) {
                            _setFilter = this._handleFilter(data.data.filter)
                        }

                        let _checkShowcase = JSON.stringify(_setRealm) + JSON.stringify(_setWithQR) + JSON.stringify(_setContent) + JSON.stringify(_setFilter)
                        
                        if(_lastShowcase != _checkShowcase) {
                            _lastShowcase = _checkShowcase

                            this.realmId = _setRealm;
                            this.showcaseWithQR = _setWithQR;
                            this.showcaseContent = _setContent;
                            this.productsFilter = _setFilter;

                            this.isLoading = true;
                            setTimeout(() => {
                                this.isLoading = false;
                            }, 500)
                        }                        
                    })
                }, 10 * 60 * 1000)
            }
            else {
                let _realm = this.environmentService.getForceRealm()
    
                if(_realm == null && params.realm) {
                    _realm = this.environmentService.getRealm(params.realm)
                }
    
                this.realmId = _realm?.id;
            }
        })
    }
}
